export const excludeProperties = <T extends object>(obj: T, exclude: (keyof T)[]) =>
    Object.entries(obj).reduce(
        (acc, [key, val]) =>
            !exclude || !exclude.includes(key as keyof T) ? { ...acc, [key]: val } : acc,
        {} as Partial<T>,
    );
